module.exports = __webpack_public_path__ + "img/munster.e5f929dd.jpg";